export { default as findCreateManyTagMutation } from './find-create-many-tag-mutation';
export { default as findManyTagQuery } from './find-many-tag-query';
